import { VideoData } from '@lumen5/luminary';

import { SCENE_DURATIONS } from 'js/src/libs/consts';

const NETFLIX_SPEED_FACTOR = 0.75;
export const defaultLanguageReadingSpeed = 20 * NETFLIX_SPEED_FACTOR; // english (default language) reading speed

export const _calculateTextDurationInMs = (
    text: string,
    paceMultiplier: number,
    readingSpeed: number,
) => {
    const charNumber = text.length;
    const charsPerSecond = readingSpeed;
    const duration = (charNumber / charsPerSecond) * 1000;
    return Math.ceil((duration * paceMultiplier) / 100);
};

export const calculateSceneDuration = (
    sentences: string[],
    sceneCategory: string | null = null,
    paceMultiplier = 100,
    readingSpeed = defaultLanguageReadingSpeed,
) => {
    const defaultDuration = (SCENE_DURATIONS.DEFAULT * paceMultiplier) / 100;
    const mergedSentences = sentences.join(' ');

    if (sceneCategory === VideoData.CATEGORY_BRAND) {
        return SCENE_DURATIONS.BRAND;
    }

    if (sceneCategory === VideoData.CATEGORY_OUTRO) {
        return (SCENE_DURATIONS.OUTRO * paceMultiplier) / 100;
    }

    // for no-text video slides, use the default duration
    const sentencesWithoutSpaces = mergedSentences.replace(/\s/g, '');
    const hasNoText = sentencesWithoutSpaces.length === 0;
    if (hasNoText || sentences.length === 0) {
        return defaultDuration;
    }

    let calculatedTextDuration = _calculateTextDurationInMs(
        mergedSentences,
        paceMultiplier,
        readingSpeed,
    );
    calculatedTextDuration = Math.min(calculatedTextDuration, SCENE_DURATIONS.MAX);
    calculatedTextDuration = Math.max(calculatedTextDuration, SCENE_DURATIONS.MIN);
    return calculatedTextDuration;
};
